<template>
  <v-container
    fill-height
    fluid
    class="deals-wrapper"
  >
    <v-layout
      v-if="!editMode && !viewMode"
      xs12
      justify-center
      wrap
    >
      <v-flex
        md5
      >
        <h2>{{ $t('deals.title') }}</h2>
      </v-flex>
      <v-flex
        md7
        xs12
        mb-0
        mt-0
        :class="!$vuetify.breakpoint.xs ? 'pt-5 text-right': 'pt-0'"
        pb-0
        text-right
      >
        <v-text-field
          v-model.trim="params.searchInput"
          name="search"
          max-length="100"
          style="width:220px"
          prepend-inner-icon="mdi-text-box-search-outline"
          @keyup="search(params.searchInput)"
          @keyup.enter="checkSearch"
          @blur="checkSearch"
        >
          <template v-slot:append>
            <v-icon
              v-if="params.searchInput"
              style="cursor:pointer"
              @click="clearSearch"
            >
              mdi-close
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>

      <v-flex
        v-if="!_.isEmpty(moduleRealEstateDeals.data)"
        xs12
      >
        <v-card>
          <v-data-table
            class="text-no-wrap deals-table"
            :headers="headers"
            :items="moduleRealEstateDeals.data"
            :server-items-length="moduleRealEstateDeals.total"
            :items-per-page="params.count"
            :page="params.page"
            :mobile-breakpoint="900"
            @update:options="loadDeals"
          >
            <template v-slot:item.status="{ item }">
              <deal-status
                :name="item.status"
              />
            </template>
            <template v-slot:item.name="{ item }">
              <div>
                <v-flex
                  class="primary--text deals-viewMode-btn"
                  @click="viewDeal(item)"
                >
                  {{ item.first_name }} {{ item.last_name }}
                </v-flex>
                <small class="deals-table-occupation">
                  {{ item.occupation }}
                  
                </small>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-menu
                offset-y
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    small
                    text
                    v-on="on"
                  >
                    {{ $t('globals.manageButton') }}
                  </v-btn>
                </template>
                <v-sheet dense>
                  <v-list-item
                    v-if="item.status !== 'completed'"
                    @click="editDeal(item)"
                  >
                    <v-list-item-title>{{ $t('globals.editButton') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="confirmDeleteDeal(item)"
                  >
                    <v-list-item-title>{{ $t('globals.deleteButton') }}</v-list-item-title>
                  </v-list-item>
                </v-sheet>
              </v-menu>
            </template>
            <template v-slot:item.transaction_amount="{ item }">
              <b>${{ item.transaction_amount || 0 }}</b>
            </template>
            <template v-slot:item.created_at="{ item }">
              <small>{{ item.created_at | moment('L LTS') }}</small>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-if="_.isEmpty(moduleRealEstateDeals.data) && !loading"
        xs12
      >
        <v-card>
          <v-flex
            xs-12
            class="not-found"
          >
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('deals.notFound') }}</p>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <edit-form
      v-if="editMode"
      :deal="selectedDeal"
      @editDeal="editDeal"
      @closeEditMode="closeEditMode"
    />
    <view-mode-window
      v-if="viewMode"
      :deal="selectedDeal"
      @editDeal="editDeal"
      @closeViewMode="closeViewMode"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('deals.reallyDelete')"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-container>
</template>

<script>
import dealStatus from "@/views/Modules/Deals/partial/dealStatus";
import editForm from "@/views/Modules/Deals/partial/NewOrEdit";
import viewModeWindow from "@/views/Modules/Deals/partial/viewMode"
import DEALS_QUERY from "@/graphql/queries/modules/realEstate/RealEstateDeals.gql";
import {mapGetters} from "vuex";
import DEAL_DELETE_MUTATION from "@/graphql/mutations/modules/realEstate/realEstateDeleteDeal.gql";
import ViewModeVue from "@/views/Modules/Deals/partial/viewMode";
const COUNT_PER_PAGE = 10;

export default {
  name: "ListVue",
  components:{viewModeWindow, dealStatus, editForm},
  data(){
    return {
      loading:true,
      count:COUNT_PER_PAGE,
      params: {
        whitelabel_uuid: null,
        page: 1,
        count:COUNT_PER_PAGE,
        fromDate: this.$moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
        toDate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        searchInput: '',
      },
      viewMode:false,
      headers:[
        {
          sortable: false,
          text: this.$t('globals.name'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('globals.status'),
          value: 'status'
        },
        {
          sortable: false,
          text: this.$t('deals.dealAmount'),
          value: 'transaction_amount'
        },
        {
          sortable: false,
          text: this.$t('deals.createdAt'),
          value: 'created_at'
        },
        {
          sortable: false,
          text: '',
          value: 'actions'
        }
      ],
      moduleRealEstateDeals:[],
      selectedDeal:null,
      editMode: false,
      confirmDialog: false
    }

  },
  computed:{
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch:{
    getWhiteLabel(val) {
      if (this.routeNotAllowed(val, 'realestatedeals')) {
        this.$router.push('/dashboard')
      }
      this.params.whitelabel_uuid = val.uuid
      this.moduleRealEstateDeals = []
      this.$apollo.queries.moduleRealEstateDeals.refetch()
    }
  },
  mounted() {
    if (this.getWhiteLabel) {
      this.params.whitelabel_uuid = this.getWhiteLabel.uuid
    }
  },
  methods:{
    search(val) {
      if(val && val.length > 2){
        this.params.searchInput = val
        this.reload(this.params.searchInput, 'search')
      }
    },
    clearSearch(){
      this.params.searchInput = ''
      this.reload(this.params.searchInput, 'search')
    },
    checkSearch(){
      if(this.params.searchInput.length<=2){
        this.clearSearch()
      }
    },
    editDeal(item) {
      this.selectedDeal = item
      this.editMode = true
      this.viewMode = false
    },
    viewDeal(item){
      this.selectedDeal = item
      this.viewMode = true
    },
    confirmDeleteDeal(item){
      this.confirmDialog = true
      this.selectedDeal = item
    },
    closeEditMode(val) {
      this.editMode = false
      this.viewMode = false
      if (val) {
        this.$apollo.queries.moduleRealEstateDeals.refetch();
      }
      this.selectedDeal = null
    },
    closeViewMode(){
      this.viewMode = false
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deleteDeal()
      }
      this.selectedProduct = null
    },
    async loadDeals({ page, itemsPerPage }){
      this.loading = true;
      this.params.count = itemsPerPage;
      this.params.page = page;
      await this.$apollo.queries.moduleRealEstateDeals.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        },
      });
      this.loading = false;
    },
    reload(value, from, nextPage = false) {
      this.loading = true
      if(!nextPage){
        this.params.page = 1;
      }
      this.params[from] = value
      this.params.fromDate = this.$moment(this.params.fromDate).format('YYYY-MM-DD HH:mm:ss')
      this.params.toDate = this.$moment(this.params.toDate).format('YYYY-MM-DD HH:mm:ss')
      this.$apollo.queries.moduleRealEstateDeals.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if(nextPage) {
            const prevData = previousResult.moduleRealEstateDeals.data;
            const fetchedData = fetchMoreResult.moduleRealEstateDeals.data;
            fetchMoreResult.moduleRealEstateDeals.data = [...prevData, ...fetchedData]
          }
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleteDeal() {
      this.loading = true;
      let params = {
        whitelabel_uuid: this.getWhiteLabel.uuid,
        deal_uuid: this.selectedDeal.uuid
      }
      this.$apollo
          .mutate({
            mutation: DEAL_DELETE_MUTATION,
            variables: params
          })
          .then(data => {
            this.$store.commit('app/setNotifier', this.$t('globals.success'));
            this.$apollo.queries.moduleProducts.refetch()
            this.reload()
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
            this.reload()
          });
    },

  },
  apollo: {
    moduleRealEstateDeals: {
      fetchPolicy: "network-only",
      query() {
        return DEALS_QUERY;
      },
      variables() {
        return this.params
      },
      skip() {
        return !this.params.whitelabel_uuid;
      },
      result(){
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" >
.deals{
  &-viewMode-btn{
    cursor:pointer;
  }
  &-table-name{
    font-weight: 600;
    color: var(--color-primary-text);
    cursor:pointer
  }
  &-wrapper{
    .v-data-table > .v-data-table__wrapper > table {
      border-spacing: 0 .5rem;
    }
    .v-data-table td {
      padding-bottom: 4px !important;
    }
  }
}
</style>
